import React, { useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { addCompanyInfo } from '../../features/appSlice';



const CompanyInfo = (props) => {
    const state = useSelector(state => state);
    const dispatch = useDispatch();
    const companyName = useRef();
    const limit = useRef();
    const phoneNumber = useRef();
    const website = useRef();
    const email = useRef();
    const previousValue = useRef(state.app.contextData.company_information.limit);
    const onChangeCompanyinfo = (e, inputRef) => {
        const enteredValue = e.target.value;
        if (limit && enteredValue.length > 0 && enteredValue.charAt(0) === '0') {

            limit.current.value = '';

        } else {
            const vv = [inputRef.current.value, inputRef.current.name];
            dispatch(addCompanyInfo(vv));

        }

        const regex = /^[0-9]*$/; // Regular expression to match only digits


        if (limit && !regex.test(enteredValue) || enteredValue.includes('+') || enteredValue.includes('-')) {

            // alert('Special characters such as + and - are not allowed in the maximum number of words per response');
            limit.current.value = '';
            // return;
        } else {
            const vv = [inputRef.current.value, inputRef.current.name];
            dispatch(addCompanyInfo(vv));
        }


        const vv = [inputRef.current.value, inputRef.current.name];
        dispatch(addCompanyInfo(vv));
    }

    const onKeyPressHandler = (e) => {
        const key = e.key;
        if (key === '+' || key === '-') {
            e.preventDefault();
        }
    };
    return (
        <div className={`tab-pane fade ${(props.activeTab === 1) && 'show active'}`} id="companyinfo" role="tabpanel" aria-labelledby="companyinfo-tab">
            <div className='col-md-12'>
                <h2 className="box-title">Basic Info</h2>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <label>Company name:</label>
                    </div>

                    <div className="col-md-6">
                        <input
                            type="text"
                            name="companyName"
                            className="form-control"
                            placeholder="Company name"
                            ref={companyName}
                            // value={state.app.contextData.company_information.companyName}
                            value={state.app.contextData.company_information.companyName}

                            onChange={(e) => onChangeCompanyinfo(e, companyName || props?.data?.company_information?.companyName)}
                        />


                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <label>Phone number:</label>
                    </div>
                    <div className="col-md-6">
                        <input
                            type="text"
                            name="phoneNumber"
                            className="form-control"
                            placeholder="Phone number"
                            ref={phoneNumber}
                            value={props?.data?.company_information?.phoneNumber
                                ?? state.app.contextData.company_information.phoneNumber}
                            onChange={(e) => onChangeCompanyinfo(e, phoneNumber || props?.data?.company_information?.phoneNumber)}

                        />
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-md-3">
                        <label>Company website:</label>
                    </div>
                    <div className="col-md-6">
                        <input
                            type="text"
                            name="website"
                            autoComplete='new-email'
                            className="form-control"
                            placeholder="Company website"
                            ref={website}
                            value={props?.data?.company_information?.website
                                ?? state.app.contextData.company_information.website}
                            onChange={(e) => onChangeCompanyinfo(e, website || props?.data?.company_information?.website)}
                        />
                    </div>
                </div>


                {/* <div className="row mb-3">
                    <div className="col-md-3">
                        <label>Your email:</label>
                    </div>
                    <div className="col-md-6">
                        <input 
                            type="text" 
                            name="email" 
                            className={`form-control ${state.app.isEmailValid && 'is-invalid'}`} 
                            placeholder="sample@example.com" 
                            ref={email} 
                            value={state.app.contextData.company_information.email}
                            onChange={(e) => onChangeCompanyinfo(e, email)} 
                        />
                    </div>
                </div> */}
                <div className="row mb-3">
                    <div className="col-md-3">
                        <label>Maximum number of words per response
                            (We suggest 50 words):</label>
                    </div>
                    <div className="col-md-6">
                        <input
                            type="number"
                            min="1"
                            name="limit"
                            className="form-control"
                            placeholder=""
                            ref={limit}
                            value={state.app.contextData.company_information.limit}
                            onKeyDown={onKeyPressHandler}
                            onChange={(e) => onChangeCompanyinfo(e, limit || state.app.contextData.company_information.limit)}
                        />
                    </div>
                </div>


            </div>
        </div>
    )
}

export default CompanyInfo